/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GTAAAACGACGGCCAGT (M13 forward primer) melts around 50 °C at 50 mM Na⁺.`)
};

const es_tm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GTAAAACGACGGCCAGT (cebador directo M13) funde alrededor de 50 °C con 50 mM de Na⁺.`)
};

const de_tm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GTAAAACGACGGCCAGT (M13-Forward-Primer) schmilzt bei etwa 50 °C bei 50 mM Na⁺.`)
};

const nl_tm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GTAAAACGACGGCCAGT (M13-forward-primer) smelt rond 50 °C bij 50 mM Na⁺.`)
};

const fr_tm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GTAAAACGACGGCCAGT (amorce directe M13) fond autour de 50 °C à 50 mM Na⁺.`)
};

const it_tm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GTAAAACGACGGCCAGT (primer forward M13) fonde intorno a 50 °C a 50 mM Na⁺.`)
};

const pt_br2_tm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GTAAAACGACGGCCAGT (primer forward M13) funde em torno de 50 °C a 50 mM de Na⁺.`)
};

const pt_tm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GTAAAACGACGGCCAGT (primer direto M13) funde por volta dos 50 °C a 50 mM de Na⁺.`)
};

const ja_tm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GTAAAACGACGGCCAGT（M13フォワードプライマー）は、Na⁺ 50 mMで約50℃で融解します。`)
};

const zh_tm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GTAAAACGACGGCCAGT（M13 正向引物）在 50 mM Na⁺ 下的解链温度约为 50 °C。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_ex1", locale)
	if (locale === "en") return en_tm_ex1(inputs)
	if (locale === "es") return es_tm_ex1(inputs)
	if (locale === "de") return de_tm_ex1(inputs)
	if (locale === "nl") return nl_tm_ex1(inputs)
	if (locale === "fr") return fr_tm_ex1(inputs)
	if (locale === "it") return it_tm_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_tm_ex1(inputs)
	if (locale === "pt") return pt_tm_ex1(inputs)
	if (locale === "ja") return ja_tm_ex1(inputs)
	return zh_tm_ex1(inputs)
};